import UploadTypes from '../upload/UploadTypes';
import { SECTION_TYPES } from '../../configs/AppConfig';

const initialState = {
  disclosureFiles: [],
  patientFiles: [],
  disclosureTotal: 0,
  disclosureTotalPages: 1,
  disclosureQueries: {
    page: 1,
    size: 10,
    keyWords: '',
    sectionType: 1
  },
  patientTotal: 0,
  patientTotalPages: 1,
  patientQueries: {
    page: 1,
    size: 10,
    keyWords: '',
    sectionType: 2
  },
  progressingFiles: [],
  deleting: new Map(),
  disclosureYears: [],
  patientYears: []
};

export default function uploadReducer (state = initialState, action) {
  const {
    type,
    payload
  } = action;
  let newState = { ...state };
  switch (type) {
    case UploadTypes.GET_DISCLOSURE_GROUP_UPLOADED_FILES_SUCCESS:
      newState.disclosureFiles = [...payload.content];
      newState.disclosureTotal = payload.totalElements;
      newState.disclosureTotalPages = Math.ceil(payload.totalElements / newState.disclosureQueries.size);
      return newState;
    case UploadTypes.UPDATE_DISCLOSURE_FILES_QUERIES:
      newState.disclosureQueries.page = payload.page;
      newState.disclosureQueries.size = payload.size;
      newState.disclosureQueries.keyWords = payload.keyWords;
      return newState;
    case UploadTypes.GET_PATIENT_GROUP_UPLOADED_FILES_SUCCESS:
      newState.patientFiles = [...payload.content];
      newState.patientTotal = payload.totalElements;
      newState.patientTotalPages = Math.ceil(payload.totalElements / newState.patientQueries.size);
      return newState;
    case UploadTypes.UPDATE_PATIENT_FILES_QUERIES:
      newState.patientQueries.page = payload.page;
      newState.patientQueries.size = payload.size;
      newState.patientQueries.keyWords = payload.keyWords;
      return newState;
    case UploadTypes.CHECK_IMPORT_PROGRESS_SUCCESS:
      newState.progressingFiles = [...payload];
      return newState;
    case UploadTypes.SET_DELETING:
      newState.deleting = payload;
      return newState;
    case UploadTypes.GET_YEARS_SUCCESS:
      if (payload.type === SECTION_TYPES.DISCLOSURE.value) {
        if (typeof payload.data === 'object') {
          newState.disclosureYears = [...payload.data];
        }
      } else {
        if (typeof payload.data === 'object') {
          newState.patientYears = [...payload.data];
        }
      }
      return newState;
    default:
      newState = state;
  }
  return newState;
}
